import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";

export const renderPulseBetIcon = (hasPulseBet: boolean, pulseBetTooltip: string) => {
    const props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: pulseBetTooltip
    };
    return (
        hasPulseBet
            ? <EventCardIcon {...props}>
                <Icon i="i-24-16 i-o-ev-pulse" />
            </EventCardIcon>
            : createEmptyTooltipIcon()
    )
}